import { Check, ClockRefresh } from '@timelyapp/icons/solid-icons';
import { Box, Button, Pill, Text } from '@timelyapp/react';
import type { Props as DatepickerProps } from 'components/datepicker/DatePicker';
import { relativeDateRanges } from 'components/datepicker/utils';
import React, { memo } from 'react';
import styles from './DayPickerRelativeDateRangesSection.module.scss';

type RelativeDateRangesSectionProps = Pick<
  DatepickerProps,
  'relativeDateRange' | 'onRelativeDateRangeSelect'
>;

const DayPickerRelativeDateRangesSection: React.FC<RelativeDateRangesSectionProps> = memo(
  ({ relativeDateRange, onRelativeDateRangeSelect }) => {
    return (
      <Box flexDirection="column" gap="small" alignItems="flex-start" padding="medium">
        <Box.Column padding="medium" className={styles.relativeDatesContainer}>
          <Text.Label size="small" color="normal">
            Dynamic date range
            <Pill variant="success" size="small" className={styles.newPill}>
              New
            </Pill>
          </Text.Label>
          <Text.Paragraph size="small" color="subtle">
            The report will automatically update to show the latest data for the selected period.
          </Text.Paragraph>
        </Box.Column>
        {relativeDateRanges.map(r => {
          const isSelected = relativeDateRange === r.value;
          return (
            <Button
              selected={isSelected}
              priority="low"
              key={r.value}
              size="small"
              onClick={e => onRelativeDateRangeSelect?.(e, r.value)}
            >
              {isSelected ? <Check /> : <ClockRefresh />}
              {r.label}
            </Button>
          );
        })}
      </Box>
    );
  }
);

export default DayPickerRelativeDateRangesSection;
